import React from 'react';
import {
    Button,
    Menu,
    MenuItem,
    MenuList,
    MenuPopover,
    MenuTrigger,
} from '@fluentui/react-components';
import { ChevronDownRegular, FlashFilled, SettingsFilled } from '@fluentui/react-icons';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { navigateSafely } from '../../../utils/navigation';

interface ArchiveAgainMenuProps {
    buttonClassName?: string;
}

export const ArchiveAgainMenu: React.FC<ArchiveAgainMenuProps> = ({ buttonClassName }) => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
        <Menu>
            <MenuTrigger disableButtonEnhancement>
                <Button className={buttonClassName} icon={<ChevronDownRegular />} iconPosition="after">{t('Archive again')}</Button>
            </MenuTrigger>
            <MenuPopover>
                <MenuList>
                    <MenuItem icon={<FlashFilled />} onClick={() => navigateSafely(navigate, '/quicksave')}>
                        {t('Quick Save')}
                    </MenuItem>
                    <MenuItem icon={<SettingsFilled />} onClick={() => navigateSafely(navigate, '/archiveMail')}>
                        {t('Advanced Save')}
                    </MenuItem>
                </MenuList>
            </MenuPopover>
        </Menu>
    );
};